
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsc5f092cc73a4bd0720d9981e641053a8en from './en.yaml'
            i18n.addResourceBundle('en', 'c5f092cc73a4bd0720d9981e641053a8', flattenObject(nsc5f092cc73a4bd0720d9981e641053a8en), true, true);
        
        export default 'c5f092cc73a4bd0720d9981e641053a8';
    